/**
 * Created by mathieudeumie on 22/07/2014.
 */

angular.module('FlexyBeautyApp.services').
factory('ProductCategoryStatView',["ProductStatView",
    function (ProductStatView)
    {
        var ProductCategoryStatView = function(productCategory,parentCategoryStatView)
        {
            this.label = "";
            this.productCategoryId = null;
            this.nbBookingsOrSales = 0;
            this.color = null;//null -> color generation
            this.parentCategoryStatView = parentCategoryStatView;

            this.equivalentProductCategory = productCategory;

            this.productCategoryStatViews = [];
            this.productStatViews = [];
            this.globalProductStatViews = [];


            this.ca = 0;

            if(productCategory)
                this.loadData(productCategory);
        };

        ProductCategoryStatView.prototype.addProductStatView = function(productStatView)
        {
            if(productStatView != undefined && productStatView != null)
            {
                this.productStatViews.push(productStatView);
                this.addGlobalProductStatView(productStatView);
            }
        };
        ProductCategoryStatView.prototype.addGlobalProductStatView = function(productStatView)
        {
            if(productStatView != undefined && productStatView != null)
            {
                if (this.globalProductStatViews.indexOf(productStatView)==-1)
                    this.globalProductStatViews.push(productStatView);
                if (this.parentCategoryStatView)
                    this.parentCategoryStatView.addGlobalProductStatView(productStatView);

            }
        };
        ProductCategoryStatView.prototype.addProductCategoryStatView = function(productCategoryStatView)
        {
            if(productCategoryStatView != undefined && productCategoryStatView != null)
                this.productCategoryStatViews.push(productCategoryStatView);
        };
        ProductCategoryStatView.prototype.loadData = function(productCategory)
        {
            this.productCategoryId = productCategory.id;
            this.setColor(productCategory);
            this.label = productCategory.label;
            for (var i = 0; i < productCategory.categories.length; i++) {
                var newProductCategoryStatViewFille = new ProductCategoryStatView(productCategory.categories[i],this);
                this.addProductCategoryStatView(newProductCategoryStatViewFille);
            }
            for (i = 0; i < productCategory.products.length; i++) {
                var newProductStatView = new ProductStatView(productCategory.products[i],this);
                this.addProductStatView(newProductStatView);
            }
        };

        ProductCategoryStatView.prototype.setColor = function(category)
        {
            if(category.style == null && category.parentCategory != undefined && category.parentCategory != null)
                this.setColor(category.parentCategory);
            if(category.style != null && category.style.indexOf("background")!=-1) {
                var index = category.style.indexOf("\"",category.style.indexOf("background") + 13);
                if (index!=-1)
                    this.color = category.style.substr(category.style.indexOf("background") + 13,index - category.style.indexOf("background") - 13 );
                else
                    this.color = category.style.substr(category.style.indexOf("background") + 13, 7);
                if (this.color=="white")//inverse for visibility
                    this.color="black";
            }
        };

        ProductCategoryStatView.prototype.setPricesFromSales = function(sales)
        {
            // Set ca values for productCategoryViews / productStatViews / customers
            var price;
            for(var i=0; i<sales.length; i++)
            {
                if (sales[i].status=="sold" || sales[i].status=="credit" || sales[i].status=="canceled"  )
                    for(var j=0; j<sales[i].saleProducts.length; j++)
                    {

                        var productStatView = this.getProductStatView(sales[i].saleProducts[j].product);
                        if ( !productStatView)
                            if (sales[i].saleProducts[j].product && sales[i].saleProducts[j].product.parentCategory)
                            {
                                var productCategoryStatView = this.getProductCategoryStatView(sales[i].saleProducts[j].product.parentCategory)
                                if (!productCategoryStatView)
                                {
                                    if (sales[i].saleProducts[j].product.parentCategory.parentCategory)//try to add category
                                    {
                                        var parentCat =  this.getProductCategoryStatView(sales[i].saleProducts[j].product.parentCategory.parentCategory);
                                        if (parentCat)
                                        {
                                            productCategoryStatView = new ProductCategoryStatView(sales[i].saleProducts[j].product.parentCategory,parentCat);
                                            parentCat.addProductCategoryStatView(productCategoryStatView);
                                            productStatView = this.getProductStatView(sales[i].saleProducts[j].product);
                                        }
                                    }
                                }
                                if (productCategoryStatView && !productStatView)
                                {
                                    productStatView = new ProductStatView(sales[i].saleProducts[j].product,productCategoryStatView);
                                    productCategoryStatView.addProductStatView(productStatView);
                                }

                            }
                            else
                            {
                                productStatView = this.getProductStatViewByLabel(sales[i].saleProducts[j].label);
                                if (!productStatView)
                                {
                                    productStatView = new ProductStatView(null,this);
                                    productStatView.label= sales[i].saleProducts[j].label;
                                    this.addProductStatView(productStatView);
                                }
                            }

                        if (productStatView != null)
                        {
                            //if(sales[i].saleProducts[j].humanResource) // online payment don't have hr
                            {
                                // set CA to productStatViews
                                price = sales[i].saleProducts[j].price - sales[i].saleProducts[j].price*sales[i].discountPercent/100;
                                productStatView.ca += price;
                                // set CA to productCategoryStatViews
                                productStatView.parentCategoryStatView.setValuesToParentCategories(price);
                                if (sales[i].status=="sold" || sales[i].status=="canceled"  )
                                    productStatView.nbBookingsOrSales+= sales[i].saleProducts[j].quantity;
                                else
                                    productStatView.nbBookingsOrSales-= sales[i].saleProducts[j].quantity;
                                productStatView.saleProducts.push(sales[i].saleProducts[j]);
                            }
                        }
                    }

            }
        };
        ProductCategoryStatView.prototype.setValuesToParentCategories = function(ca)
        {
            this.ca += ca;
            this.nbBookingsOrSales++;
            if(this.parentCategoryStatView != null)
                this.parentCategoryStatView.setValuesToParentCategories(ca);
        };

        ProductCategoryStatView.prototype.getProductStatView = function(product)
        {
            var productStatView = null;
            if (product)
            {
                for(var i=0; i<this.productStatViews.length; i++)
                {
                    if(this.productStatViews[i].productId == product.id)
                        productStatView = this.productStatViews[i];
                }
                if(productStatView == null && this.productCategoryStatViews.length > 0)
                {
                    for(i=0; i<this.productCategoryStatViews.length; i++)
                    {
                        productStatView = this.productCategoryStatViews[i].getProductStatView(product);
                        if(productStatView != null)
                            return productStatView;
                    }
                }
            }
            return productStatView;
        };

        ProductCategoryStatView.prototype.getProductStatViewByLabel = function(label)
        {
            var productStatView = null;
            if (label)
            {
                for(var i=0; i<this.productStatViews.length; i++)
                {
                    if(this.productStatViews[i].label == label)
                        productStatView = this.productStatViews[i];
                }
                if(productStatView == null && this.productCategoryStatViews.length > 0)
                {
                    for(i=0; i<this.productCategoryStatViews.length; i++)
                    {
                        productStatView = this.productCategoryStatViews[i].getProductStatViewByLabel(label);
                        if(productStatView != null)
                            return productStatView;
                    }
                }
            }
            return productStatView;
        };

        ProductCategoryStatView.prototype.getProductCategoryStatView = function(productCategory)
        {
            var productStatView = null;
            if (productCategory) {
                if (productCategory.id == this.productCategoryId)
                    return this;

                for (var i = 0; i < this.productCategoryStatViews.length; i++) {
                    productStatView = this.productCategoryStatViews[i].getProductCategoryStatView(productCategory);
                    if (productStatView != null)
                        return productStatView;
                }
            }
            return productStatView;
        };


        ProductCategoryStatView.prototype.getProductCategoryStatViewById = function(id)
        {
            if(this.productCategoryStatViews[id] != undefined)
                return this.productCategoryStatViews[id];
            else
                return null;
        };
        ProductCategoryStatView.prototype.getProductStatViewById = function(id)
        {
            if(this.productStatViews[id] != undefined)
                return this.productStatViews[id];
            else
                return null;
        };


        ProductCategoryStatView.prototype.clearValues = function()
        {
            this.clearPrices();
            this.clearNbBookings();
        };
        ProductCategoryStatView.prototype.clearPrices = function()
        {
            this.ca = 0;
            for(var i=0; i<this.productStatViews.length; i++)
            {
                this.productStatViews[i].ca = 0;
                this.productStatViews[i].saleProducts = [];
            }
            for(i=0; i<this.productCategoryStatViews.length; i++)
            {
                this.productCategoryStatViews[i].clearPrices();
            }
        };
        ProductCategoryStatView.prototype.clearNbBookings = function()
        {
            this.nbBookingsOrSales = 0;
            for(var i=0; i<this.productStatViews.length; i++)
                this.productStatViews[i].nbBookingsOrSales = 0;
            for(i=0; i<this.productCategoryStatViews.length; i++)
                this.productCategoryStatViews[i].clearNbBookings();
        };

        return ProductCategoryStatView;
    }]);


// WEBPACK FOOTER //
// ./js/services/views/statistics/ProductCategoryStatView.js